module.exports = __webpack_public_path__ + "static/media/car-dash.2c5d4cd7.svg";